function handleBounce(e, yCoordinate) {
    const top = e.touches[0].clientY;

    // Determine scroll position and direction.
    const { scrollTop } = e.currentTarget;
    const direction = yCoordinate - top < 0 ? 'up' : 'down';

    // FIX IT!
    if (scrollTop === 0 && direction === 'up') {
        // Prevent scrolling up when already at top as this introduces a freeze.
        e.preventDefault();
    } else if (scrollTop >= e.currentTarget.scrollHeight - e.currentTarget.offsetHeight && direction === 'down') {
        // Prevent scrolling down when already at bottom as this also introduces a freeze.
        e.preventDefault();
    }

    return top;
}

export { handleBounce };
